import errors from '@/constants/errors';

const errorHandler = (errorObject, err, method = 'generic') => {
  if (err && err.response && err.response.status) {
    const status = err.response.status;
    const errorMessage = errors[errorObject][method][status];
    return { status, ...errorMessage || 'Something went wrong, try again later.' };
  }
};

export default errorHandler;
